import { SettingSwatches } from "@ts/sanity";
import { useStaticQuery, graphql } from "gatsby";

export type UseSwatches = {
  items: SettingSwatches[];
  getSwatches: () => SettingSwatches[];
  getSwatch: (value: string) => SettingSwatches | false;
};

export const useSwatches = (): UseSwatches => {
  const { swatches } = useStaticQuery(graphql`
    query SANITY_SETTINGS_SWATCHES {
      swatches: allSanitySettingSwatches {
        edges {
          node {
            id: _id
            name
            slug {
              current
            }
            linked
            colour {
              hex
            }
            image {
              asset {
                url
              }
            }
          }
        }
      }
    }
  `);
  const items = swatches?.edges?.map(({ node }) => node) || [];

  const getSwatches = (): SettingSwatches[] =>
    items.map((swatch) => ({
      name: swatch?.name,
      slug: swatch?.slug?.current,
      linked: swatch?.linked,
      colour: swatch?.colour?.hex,
      image: swatch?.image?.asset?.url || false,
    })) || [];

  const getSwatch = (value: string): SettingSwatches | false => {
    const swatches = getSwatches().filter(
      (swatch) =>
        swatch?.name?.toLowerCase() === value?.toLowerCase() ||
        swatch?.linked
          ?.map((item) => item.toLowerCase())
          .includes(value?.toLowerCase()),
    );
    return swatches?.length ? swatches[0] : false;
  };

  return {
    items,
    getSwatches,
    getSwatch,
  };
};
